import React, { useEffect, useState } from "react";
import { useAlpineStore } from "@arctheme-hooks/useAlpineStore";
import ModelView from "./CollectionActions/ModelView";
import Sort from "./CollectionActions/Sort";
import Filters from "./CollectionActions/Filters";
import cloneDeep from "lodash/cloneDeep";
import {CollectionSidebar} from "@src/stories/ecommerce/Collection/CollectionSidebar";
import {CollectionToolbar} from "@src/stories/ecommerce/Collection/CollectionToolbar";
import {LoadingSpinner} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/LoadingSpinner/LoadingSpinner";
import {PromotionTile} from "@mindarc/arctheme-components/frontend/src/stories/components/ecommerce/PromotionalTile/PromotionTile";
import {ProductTile} from "@arctheme-components/ecommerce/Product/ProductTile";

export const DefaultCollectionProvider = ({ isFiltering, products, settings, isSidebarVisible, toggleSidebar, displayedProductsWithPromoBlocks }) => {
    const store: any = useAlpineStore("modelview");
    const [selectedOption, setSelectedOption] = useState(cloneDeep(window.defaultSort));
    const {
        columns_mobile,
        columns_desktop,
        column_gap_mobile,
        column_gap_desktop,
        row_gap_mobile,
        row_gap_desktop,
        id,
    } = settings.section;

    return (
        <div
            x-init={`initialise('${settings.collection.handle}', true, ${settings.collection_size}, ${settings.pagination_type})`}>
            <CollectionSidebar
                isVisible={isSidebarVisible}
                filters={settings.collection_filters}
                metaobject_filters={settings.filters}
                toggleSidebar={toggleSidebar}
            />
            <div className="collection__toolbar flex justify-between mb-6 lg:mb-12 items-center">
                <CollectionToolbar settings={settings} toggleSidebar={toggleSidebar}/>
            </div>
            <div
                id="product-grid"
                className={`collection__product-grid relative grid grid-cols-${columns_mobile} lg:grid-cols-${columns_desktop} gap-x-[${column_gap_mobile}px] lg:gap-x-[${column_gap_desktop}px] gap-y-[${row_gap_mobile}px] lg:gap-y-[${row_gap_desktop}px] auto-cols-max`}
                data-id={id}
            >
                <LoadingSpinner id="spinner-collection"/>

                {isFiltering.current ? (
                    <>
                        {products.map((block, index) => (
                            <React.Fragment key={index}>
                                <div className={"collection-tile"}>
                                    <ProductTile settings={settings} product={block} siblings={null}
                                                 isLazy={index > 4}/>
                                </div>
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    <>
                        {displayedProductsWithPromoBlocks.map((block, index) => (
                            <React.Fragment key={index}>
                                {block.type === "promo" ? (
                                    <PromotionTile settings={settings} promotion={block}/>
                                ) : (
                                    <div className={"collection-tile"}>
                                        <ProductTile settings={settings} product={block} siblings={null}
                                                     isLazy={index > 4}/>
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
};
